module.exports = __webpack_public_path__ + "img/css3.a20581b6.svg";